<template>
    <section class="mx-2 my-6" :aria-labelledby="goalTitleId">
        <div class="flex flex-col gap-4">
            <p v-if="goal.target_date" class="scaffold-body-small text-ink-muted">
                Due <time :datetime="goal.target_date">{{ formattedTargetDate }}</time>
            </p>

            <BaseCard theme="default" padding="none" radius="lgr" elevated class="overflow-hidden">
                <div class="flex items-start gap-3 px-5 py-5 sm:px-7 sm:py-6">
                    <DevelopmentGoalHourglass class="mt-1 size-[22px] shrink-0" />
                    <div class="min-w-0 grow">
                        <div class="flex items-start gap-2">
                            <h2 :id="goalTitleId" class="title-body min-w-0 grow text-ink">{{ goal.title }}</h2>
                            <BaseChip size="2xs" class="mt-0.5 shrink-0">Draft</BaseChip>
                        </div>
                        <p class="mt-2 body text-ink-muted">{{ goal.achievement_criteria }}</p>
                    </div>
                </div>
            </BaseCard>
        </div>
    </section>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import BaseChip from "~vue/components/BaseChip.vue";
import DevelopmentGoalHourglass from "~vue/icons/DevelopmentJourneyHourglass.vue";
import type { DevelopmentGoalDraft } from "~vue/types/chat";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { DateTime } from "luxon";
import { computed, onMounted, useId } from "vue";

const props = defineProps<{ goal: DevelopmentGoalDraft; coachingSessionUuid?: string | null }>();
const goalTitleId = useId();

onMounted(() => {
    void logUserInteraction(AmplitudeEventNames.DEVELOPMENT_JOURNEYS_GOAL_CARD_VIEWED, {}, props.coachingSessionUuid ?? undefined);
});

const formattedTargetDate = computed(() => {
    if (!props.goal.target_date) {
        return "";
    }

    const targetDate = DateTime.fromISO(props.goal.target_date, { zone: "utc" });

    return targetDate.isValid ? targetDate.toFormat("LLLL d, yyyy") : props.goal.target_date;
});
</script>
